import { api } from "./client";
import type { CertificateInfoVO, MetadataVO, NeedLocateVO } from "./types/common.js";

/**
 * 下载文件 (GET) - 自动触发下载
 * GET /api/v1/basic/read-file
 * @param path 文件路径
 * @param filename 下载文件名（可选）
 */
export function readFile(path: string, filename?: string): Promise<void> {
  return api.download("/basic/read-file", {
    params: { path },
    ...(filename ? { filename } : {}),
  });
}

/**
 * 获取文件 Blob（用于预览）
 * GET /api/v1/basic/read-file
 * @param path 文件路径
 * @returns Promise<{ blob: Blob; filename: string; url: string }>
 */
export async function getFileBlob(path: string): Promise<{ blob: Blob; filename: string; url: string }> {
  const result = await api.getBlob("/basic/read-file", { params: { path } });
  const url = URL.createObjectURL(result.blob);
  return { ...result, url };
}

/**
 * 获取元数据
 * GET /api/v1/basic/metadata
 */
export function getMetadata(): Promise<MetadataVO> {
  return api.get<MetadataVO>("/basic/metadata");
}

/**
 * 证件信息识别
 * POST /api/v1/basic/ocr/id-card
 *
 * 文件base64，和file二选一
 *
 */
export function identifyIdCard(data: FormData): Promise<CertificateInfoVO> {
  return api.post<CertificateInfoVO>("/basic/ocr/id-card", data);
}

/**
 * 判断是否需要定位
 * GET /api/v1/basic/need-locate
 *
 * @returns Promise<NeedLocateVO> 返回是否需要定位的配置
 * - needLocate: true 表示需要调用定位功能
 * - needLocate: false 表示不需要定位，默认地址为香港
 */
export function checkNeedLocate(): Promise<boolean> {
  return api.get<boolean>("/basic/need-locate");
}
